import adminApi from "./adminApiClient";

/**
 * Backend routes live under /api/metered/*
 * - GET    /api/metered/meters
 * - POST   /api/metered/meters
 * - PATCH  /api/metered/meters/:id
 * - GET    /api/metered/sessions
 * - GET    /api/metered/sessions/:id
 * - POST   /api/metered/sessions/open
 * - POST   /api/metered/sessions/:id/record
 * - POST   /api/metered/sessions/:id/close
 */

export async function listMeters(params = {}) {
  const res = await adminApi.get("/api/metered/meters", { params });
  return res.data;
}

export async function createMeter(payload) {
  const res = await adminApi.post("/api/metered/meters", payload);
  return res.data;
}

export async function updateMeter(id, payload) {
  const res = await adminApi.patch(`/api/metered/meters/${id}`, payload);
  return res.data;
}

export async function listSessions(params = {}) {
  const res = await adminApi.get("/api/metered/sessions", { params });
  return res.data;
}

export async function getSession(id) {
  const res = await adminApi.get(`/api/metered/sessions/${id}`);
  return res.data;
}

export async function openSession(payload) {
  const res = await adminApi.post("/api/metered/sessions/open", payload);
  return res.data;
}

export async function recordSession(id, payload) {
  const res = await adminApi.post(`/api/metered/sessions/${id}/record`, payload);
  return res.data;
}

export async function closeSession(id, payload) {
  const res = await adminApi.post(`/api/metered/sessions/${id}/close`, payload);
  return res.data;
}
